import React, { useEffect } from "react";
import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import {MAN_PL_CONST} from "../../../../../constants/ActionEnums/ManActionEnums";
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";
import {InitiateProcessAction} from "../../../../../api/omnimap/omnimapActions";

function PlaatsInBudget() {
  useEffect(() => {
    $("#plaats_in_budget").on("show.bs.modal", function (event) {
      GC.GetEntityList(
        process.env.REACT_APP_CATALOG_BUDGET,
        1,
        30,
        CallBackFunctions.BudgetCallback,
        window.$mm_management_units_token
      );
    });
  });

  const handleSubmit = () => {
    $("#cover-spin").show(0);
    var budgetId = $("input[name=budget]:checked").attr("id");
    var element = $("input[name=budget]:checked");
    var label = $(element).next("label").attr("for", budgetId);
    var model = { budget: budgetId };
    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    GC.StartActivity(
      model,
      selectedIds,
      "57d136a2-9749-46d4-85c4-edda4de75409",
      budgetVerplaatst,
      window.$mm_management_units_token
    );

    // const model = {
    //   "action": MAN_PL_CONST.PLACE_IN_WORK_PLAN,
    //   "werkplan_identification": workPlanId,
    //   "identifications": GetSelected()
    // }


    InitiateProcessAction(model, MAN_PL_CONST.END_POINT).then(()=>{

      $("#plaats_in_werkplan").modal("hide");
      window.$mm_schedule_tableReload();

    }).catch(()=>{
      alert('Something went wrong!')
      $("#cover-spin").hide(0);
    })

    function budgetVerplaatst() {
      GC.sleep(500).then(() => {
        $("#plaats_in_budget").modal("hide");
        window.$mm_schedule_tableReload();
        /*omnimap
          .FillTableAction(
            window.$mm_schedule_lastUsedTableFilter,
            1,
            window.$mm_management_units_token
          )
          .then((result) => {
            CallBackFunctions.FillTableCallBack(result, 1);
          });*/
      });
    }
  };

  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="plaats_in_budget"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Plaats in budget</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <input
              type="search"
              className="modal-search"
              placeholder="Zoeken naar budgetten"
            />
            <div className="modal-scroll">
              <div id="budget-grp" className="radio-grp" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="save_budget"
              className="btn-modal"
              onClick={handleSubmit}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlaatsInBudget;
